import { render } from "./HjpDataList.vue?vue&type=template&id=4ae5bf85&ts=true"
import script from "./HjpDataList.vue?vue&type=script&lang=ts"
export * from "./HjpDataList.vue?vue&type=script&lang=ts"

import "./HjpDataList.vue?vue&type=style&index=0&id=4ae5bf85&lang=scss"

import exportComponent from "/builds/harapan-jaya/hjp/hjp-cms/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__